<template>
  <div class="editor">
    <editor v-model="editorValue" :init="init"></editor>
  </div>
</template>
<script>
// npm i @tinymce/tinymce-vue@3 tinymce@5 tinymce-i18n@22 @npkg/tinymce-plugins
import tinymce from 'tinymce/tinymce.js'

import 'tinymce/skins/ui/oxide/skin.css'
import 'tinymce/themes/silver'

// Icon
import 'tinymce/icons/default'

import 'tinymce/plugins/emoticons'
import 'tinymce/plugins/emoticons/js/emojis.js'
import 'tinymce/plugins/table'
import 'tinymce/plugins/quickbars'

import 'tinymce-i18n/langs5/zh_CN.js'
import '@npkg/tinymce-plugins/importword'
import '@npkg/tinymce-plugins/imagetools'
import '@npkg/tinymce-plugins/table'

// TinyMCE-Vue
import Editor from '@tinymce/tinymce-vue'

export default {
  components: {
    Editor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    plugins: {
      type: [String, Array],
      default: 'quickbars emoticons table importword'
    },
    toolbar: {
      type: [String, Array],
      default:
        ' bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify|bullist numlist ' +
        ' |outdent indent blockquote | undo redo | axupimgs | removeformat | emoticons |table importword'
    }
  },
  data () {
    return {
      init: {
        language: 'zh_CN',
        height:  200,
        menubar: false,
        content_css: false,
        skin: false,
        plugins: this.plugins,
        toolbar: this.toolbar,
        quickbars_insert_toolbar: false,
        branding: false,
        statusbar: false
      },
      editorValue: this.value
    }
  },
  mounted () {
    tinymce.init({})
  },
  watch: {
    value (newValue) {
      this.editorValue = newValue
    },
    editorValue (newValue) {
      this.$emit('input', newValue)
    }
  },
  methods: {}
}
</script>
